import { Injectable, Injector } from '@angular/core';
import { AuthenticationService } from './authentication.service'
import { SocialAuthService, GoogleLoginProvider } from "@abacritt/angularx-social-login";

@Injectable()
export class SocialAuth {

    constructor(
        private authService: AuthenticationService,
        private injector: Injector
    ) { }

    /**
     * O `SocialAuthService` é resolvido só no primeiro uso (login ou logout).
     *
     * POR QUE NÃO INJETAR NO CONSTRUTOR: criar o serviço faz o
     * `@abacritt/angularx-social-login` inicializar os providers, e o
     * GoogleLoginProvider baixa o `accounts.google.com/gsi/client`. Como a
     * `tabs.page` — a shell inicial — injeta este wrapper, o gsi entrava em TODA
     * sessão (97 kB aos 2.320ms, medido em prod na /viaroma em 06/08/2026), mesmo
     * para quem nunca vai fazer login. Na tabs o único uso é `logoutWithGoogle()`,
     * dentro do handler de logout.
     */
    private get social(): SocialAuthService {
        return this.injector.get(SocialAuthService);
    }

    login() {
        // GIS (Google Identity Services): o signIn() programático do gapi não existe
        // mais; getAccessToken() abre o popup OAuth do token client e resolve com o
        // access_token — o mesmo formato que o backend já consome (loginMode gmail).
        return new Promise((resolve, reject) => {
            this.social.getAccessToken(GoogleLoginProvider.PROVIDER_ID).then(accessToken => {

                let user = {
                    access_token: accessToken,
                    loginMode: "gmail",
                };

                // Espera o login no server: a recusa dele (ex.: 429 do limite por IP da
                // server!9150) tem de chegar à tela, em vez de fechar o modal como se tivesse entrado.
                this.authService.login(user, "gmail").then(() => resolve(user), reject);
            }).catch(err => reject(err));
        })
    }

    logoutWithGoogle() {
        this.social.signOut();
    }
}
